module.exports = {
	"id": "KY",
	"name": "Cayman Islands",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": 0.012158,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.006079,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.012158,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": 0.006079,
			"22": 0.018237,
			"23": null,
			"24": null,
			"25": 0.012158,
			"26": 0.012158,
			"27": 0.012158,
			"28": 0.006079,
			"29": 0.012158,
			"30": null,
			"31": 0.012158,
			"32": null,
			"33": 0.006079,
			"34": 0.36474,
			"35": 0.072948,
			"36": 0.024316,
			"37": 0.054711,
			"38": 0.030395,
			"39": 0.012158,
			"40": 0.024316,
			"41": 0.079027,
			"42": 0.018237,
			"43": 0.042553,
			"44": 0.036474,
			"45": 0.030395,
			"46": 0.085106,
			"47": 0.085106,
			"48": 0.024316,
			"49": 1.720357,
			"50": 0.158054,
			"51": 0.370819,
			"52": 0.632216,
			"53": 23.580441,
			"54": 5.750734,
			"55": 0.030395,
			"56": 0.012158,
			"57": null
		},
		"firefox": {
			"2": 0.012158,
			"3": 0.024316,
			"4": null,
			"5": null,
			"6": null,
			"7": 0.018237,
			"8": 0.151975,
			"9": null,
			"10": null,
			"11": null,
			"12": 0.024316,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.006079,
			"19": 0.018237,
			"20": null,
			"21": null,
			"22": null,
			"23": 0.054711,
			"24": 0.042553,
			"25": 0.042553,
			"26": 0.012158,
			"27": 0.200607,
			"28": null,
			"29": 0.024316,
			"30": null,
			"31": 0.024316,
			"32": 0.012158,
			"33": 0.036474,
			"34": 0.24316,
			"35": 0.048632,
			"36": 0.133738,
			"37": 0.079027,
			"38": 0.042553,
			"39": 0.018237,
			"40": 0.036474,
			"41": 0.036474,
			"42": 0.036474,
			"43": 0.18237,
			"44": 0.054711,
			"45": 0.091185,
			"46": 0.091185,
			"47": 0.443767,
			"48": 0.449846,
			"49": 5.331283,
			"50": 0.048632,
			"51": null,
			"52": null,
			"3.5": 0.212765,
			"3.6": 0.072948
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.012158,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": null,
			"37": 0.048632,
			"38": null,
			"39": 0.018237,
			"40": 0.395135,
			"41": 0.006079,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.042553
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.006079,
			"6": 0.006079,
			"7": 0.48632,
			"8": 0.145896,
			"9": 0.407293,
			"10": 2.753787,
			"3.1": null,
			"3.2": null,
			"5.1": 0.072948,
			"6.1": 0.103343,
			"7.1": 0.006079,
			"9.1": 1.878411
		},
		"ios_saf": {
			"8": 0,
			"10": 11.126273348,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.299840192236,
			"8.1-8.4": 0.553942050062,
			"9.0-9.2": 0.26426593214,
			"9.3": 4.03174947752
		},
		"android": {
			"3": 0,
			"4": 0.0382272170543,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00477840213178,
			"4.1": 0.137891032946,
			"4.2-4.3": 0.344727582364,
			"4.4": 0.790484238372,
			"4.4.3-4.4.4": 0.797310527132
		},
		"ie": {
			"6": null,
			"7": 0.006079,
			"8": 0.212765,
			"9": 0.30395,
			"10": 0.322187,
			"11": 6.857112,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0221730076209,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000615916878358
		},
		"edge": {
			"12": 0.164133,
			"13": 0.516715,
			"14": 1.975675
		},
		"ie_mob": {
			"10": 0.0633987042254,
			"11": 0.258123295775
		},
		"bb": {
			"7": 0.098025,
			"10": null
		},
		"samsung": {
			"0": 4.732647
		},
		"and_uc": {
			"0": 0.462678
		},
		"op_mini": {
			"0": 0.298733075501
		},
		"and_chr": {
			"0": 15.949454
		},
		"and_ff": {
			"0": 0.086262
		}
	},
	"total": 98.835501
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/KY.json
 ** module id = 569
 ** module chunks = 0
 **/